module.exports = __webpack_public_path__ + "static/img/Bachelor_010397.0b3a587.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010397.jpg
// module id = 158
// module chunks = 0